import { defBaseUnit, defCustomUnit, defInvertedUnit } from '../registry';

// Unit group to capture efficiency of electric cars, paralleling fuelEconomy
export const energyEconomyUnits = [
  defBaseUnit('kWh/km', 'kilowatt-hour/kilometer'),
  defCustomUnit('kWh/mile', 'kilowatt-hour/mile', 'kWh/km', 0.621371),
  defInvertedUnit('mile/kWh', 'mile/kilowatt-hour', 'kWh/km', 0.621371),
  defInvertedUnit('km/kWh', 'kilometer/kilowatt-hour', 'kWh/km', 1),
];
